const PRODUCT_DISPLAY = {
  PORTFOLIO: "Jarvis Portfolio",
  RMS: "Jarvis Protect",
  ONESTOCK: "Jarvis OneStock",
  PRIME: "Jarvis Prime",
  SENTIMENT: "Sentiment Tracker",
};

const FREQUENCY_DISPLAY = {
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
  HALF_YEARLY: "Half-Yearly",
  QUARTERLY: "Quarterly",
};

/** Product chrome for Manage Subscription (Figma 7942:93644). */
const PRODUCT_META = {
  PORTFOLIO: {
    displayName: "Jarvis Portfolio",
    group: "Investing Essentials",
    tagline: "Investing Powered by AI",
    icon: "/images/product-info/portfolio-3d.png",
  },
  RMS: {
    displayName: "Jarvis Protect",
    group: "Investing Essentials",
    tagline: "Risk managed for you",
    icon: "/images/product-info/protect-3d.png",
  },
  ONESTOCK: {
    displayName: "Jarvis OneStock",
    group: "Investing Essentials",
    tagline: "Focused stock ideas",
    icon: "/images/product-info/onestock-3d.png",
  },
  SENTIMENT: {
    displayName: "Sentiment Tracker",
    group: "Investing Essentials",
    tagline: "Market mood, simplified",
    icon: "/images/product-info/sentiment-3d.png",
  },
  PRIME: {
    displayName: "Jarvis Prime",
    group: "Private Wealth",
    tagline: "Private wealth, powered by AI",
    icon: "/images/product-info/prime-3d.png",
  },
};

const TIER_RE = /\b(Premium|Plus|Basic|Standard|Pro)\b/i;

export const STATUS_COLOR = {
  COMPLETED: "#16A34A",
  UPCOMING: "#eda500",
  PENDING: "#eda500",
  FAILED: "#DC2626",
  REFUNDED: "#6B7280",
  PARTIAL: "#D97706",
};

export const PLAN_STATUS_META = {
  ACTIVATED: { label: "Active", color: "#00E676", bg: "rgba(0, 215, 0, 0.1)", border: "#00E676" },
  EXPIRED: { label: "Expired", color: "#d44c4c", bg: "rgba(212, 76, 76, 0.1)", border: "#d44c4c" },
  CANCELLED: { label: "Cancelled", color: "#df873a", bg: "rgba(223, 135, 58, 0.1)", border: "#df873a" },
  PAUSED: { label: "Paused", color: "#df873a", bg: "rgba(223, 135, 58, 0.1)", border: "#df873a" },
};

export const getProductMeta = (productCode = "") => {
  const meta = PRODUCT_META[productCode];
  if (meta) return meta;

  return {
    displayName: PRODUCT_DISPLAY[productCode] || "Subscription",
    group: "Subscription",
    tagline: "",
    icon: "/images/product-info/portfolio-3d.png",
  };
};

export const getFrequencyDisplay = (paymentFrequency = "") =>
  FREQUENCY_DISPLAY[paymentFrequency] ||
  frequencyFromText(paymentFrequency) ||
  "";

const titleCase = (value = "") =>
  `${String(value).charAt(0).toUpperCase()}${String(value).slice(1).toLowerCase()}`;

const stripTierFromName = (name = "") =>
  String(name)
    .replace(/\s+(Premium|Plus|Basic|Standard|Pro)$/i, "")
    .trim();

const frequencyFromText = (text = "") => {
  if (/half[\s_-]?yearly/i.test(text)) return "Half-Yearly";
  if (/yearly/i.test(text)) return "Yearly";
  if (/monthly/i.test(text)) return "Monthly";
  if (/quarterly/i.test(text)) return "Quarterly";
  return "";
};

export const getBillingProductName = (row = {}) => {
  if (PRODUCT_DISPLAY[row.productCode]) {
    return PRODUCT_DISPLAY[row.productCode];
  }

  if (row.productName) {
    return stripTierFromName(row.productName) || row.productName;
  }

  if (row.planName) {
    return stripTierFromName(row.planName) || row.planName;
  }

  return "—";
};

export const getBillingPlanType = (row = {}) => {
  const freq =
    FREQUENCY_DISPLAY[row.paymentFrequency] ||
    frequencyFromText(row.paymentFrequency) ||
    frequencyFromText(row.planName) ||
    frequencyFromText(row.planType);

  let tier = row.planTier || "";
  // Ignore planType when API echoes the full plan/product name into it.
  if (
    row.planType &&
    row.planType !== row.planName &&
    row.planType !== row.productName &&
    !PRODUCT_DISPLAY[row.planType]
  ) {
    tier = tier || row.planType;
  }

  if (!tier && row.planName) {
    const match = row.planName.match(TIER_RE);
    if (match) tier = match[1];
  }

  if (!tier && row.productName) {
    const match = row.productName.match(TIER_RE);
    if (match) tier = match[1];
  }

  const normalizedTier = tier ? titleCase(tier) : "";

  if (freq && normalizedTier) return `${freq} (${normalizedTier})`;
  if (freq) return freq;
  if (normalizedTier) return normalizedTier;
  return "—";
};

export const getBillingStatusLabel = (status) => {
  if (!status) return "NA";
  if (status === "PARTIAL") return "Partial Refund";
  return titleCase(status);
};
